<template>
  <div class="oauth">
    <OAuthCredentials />
    <OAuthRedirectUrls class="oauth__redirect-urls" />
  </div>
</template>

<script>
import OAuthCredentials from './OAuthCredentials';
import OAuthRedirectUrls from './OAuthRedirectUrls';

export default {
  name: 'OAuth',
  components: {
    OAuthCredentials,
    OAuthRedirectUrls,
  },
};
</script>

<style lang="scss">
.oauth {
  &__redirect-urls {
    margin-top: $global-margin;
  }
}
</style>
